import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listRewardHistoryUsers, updateRewardPoints } from "../../Redux/Actions/rewardsAction";
import { columnsDoneRewardsUserPoints } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
import TableComponentsCp from "../../Global Functions/tableComponentsCp";

const ListDoneUserRewards = () => {
  const dispatch = useDispatch();

  const [tempSearch, setTempSearch] = useState(""); 
  const [searchQuery, setSearchQuery] = useState(""); 

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = useCallback(
    (page, limit, showLoader = true) => {
      const payload = {
        page,
        limit,
        is_deleted: false,
        search: searchQuery,  
      };
      dispatch(listRewardHistoryUsers(payload, showLoader)).catch(() => {
        if (!showLoader) {
          toast.error("Failed to refresh reward history list");
        }
      });
    },
    [dispatch, searchQuery]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  const rewardHistory = useSelector((state) => state.rewards?.rewardHistoryList || {});
  const loading = useSelector((state) => state.rewards?.loading);

  useEffect(() => {
    if (rewardHistory?.total) {
      setPagination((prev) => ({
        ...prev,
        total: rewardHistory.total,
      }));
    }
  }, [rewardHistory]);

  const handleTableChange = (pager) => {
    setPagination(pager);
    // fetchDetails(pager.current, pager.pageSize);
  };

  // When search button is clicked, update the actual searchQuery state:
  const filterHandler = () => {
    setSearchQuery(tempSearch);  
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleStatusChange = async (record, action) => {
    if (action === "active" || action === "inactive") {
      const payload = {
        id: record._id,
        status: action,
      };
      await dispatch(updateRewardPoints(payload));
      fetchDetails(pagination.current, pagination.pageSize);
    }
  };

  return (
    <TableComponentsCp
      h3heading="Done User Reward List"
      pagination={pagination}
      onChange={handleTableChange}
      columns={columnsDoneRewardsUserPoints(handleStatusChange)}
      dataSource={Array.isArray(rewardHistory?.data) ? rewardHistory.data : []}
      loading={loading}
      setState={setTempSearch}    
      filterFunction={filterHandler} 
    />
  );
};

export default ListDoneUserRewards;
